















































































































































































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

import { subscriptionOnlineBookingConfigFields } from '@/config/online-booking-config';
import BpcFormProvider from '@shared/components/forms/form-provider.vue';
import BpcInput from '@shared/components/forms/inputs/input/input.vue';
import BpcMultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import BpcDatepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import BpcInputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import BpcTextarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import BpcSwitch from '@shared/components/forms/inputs/switch/switch.vue';
import BpcEntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import { Subscription } from 'rxjs';
import BpcSwitchWithDescription from '@shared/components/forms/inputs/switch-with-description.vue';
import BpcSection from '@shared/components/forms/inputs/section/section.vue';
import {
  SubscriptionOnlineBookingConfig,
  SubscriptionOnlineBookingConfigErrorsObject,
} from '@subscriptions/interfaces/subscription-online-booking-config';
import {
  OnlineBookingConfigWithDiscipline,
  OnlineBookingConfigWithResource,
} from '@centers/interfaces/online-booking-config';

@Component({
  name: 'bpc-subscription-online-booking-config-form',
  components: {
    BpcFormProvider,
    BpcInput,
    BpcMultiSelect,
    BpcDatepicker,
    BpcInputGroup,
    BpcTextarea,
    BpcSwitch,
    BpcEntitySelect,
    BpcSwitchWithDescription,
    BpcSection,
  },
})
export default class SubscriptionOnlineBookingConfigForm extends Vue {
  @Prop(Object) readonly value: SubscriptionOnlineBookingConfig;
  @Prop(Array) readonly disciplinesForOnlineBookingIds: number[];
  @Prop(Array) readonly resourcesForOnlineBookingIds: number[];

  loading = false;
  loadingDisciplineOnlineBookingConfig = false;
  loadingResourceOnlineBookingConfig = false;
  disciplineOnlineBookingConfigSubscription: Subscription = null;
  resourceOnlineBookingConfigSubscription: Subscription = null;
  errorsObject: SubscriptionOnlineBookingConfigErrorsObject = {};
  disciplineOnlineBookingConfigCollection: OnlineBookingConfigWithDiscipline[] = [];
  resourceOnlineBookingConfigCollection: OnlineBookingConfigWithResource[] = [];

  get formModel() {
    return this.value;
  }

  set formModel(value: SubscriptionOnlineBookingConfig) {
    this.$emit('input', value);
  }

  get noLabel() {
    return {
      labelAttributes: {
        for: 'no_label',
      },
    };
  }

  get disciplinesChangeDetectorStr() {
    return this.disciplinesForOnlineBookingIds.join(',');
  }
  get resourcesChangeDetectorStr() {
    return this.disciplinesForOnlineBookingIds.join(',');
  }

  get fieldsConfig() {
    return subscriptionOnlineBookingConfigFields;
  }

  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 pl-2': true,
        },
      },
    };
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 pl-2': true,
        },
      },
    };
  }

  get allowedDurationsDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    const disciplineItems = this.disciplineOnlineBookingConfigCollection.map(item => ({
      name: item.discipline_name,
      description: this.optionValuesToLabel(
        item.online_booking_config.allowed_durations,
        this.fieldsConfig.allowed_durations.options,
      ).join(', '),
      id: item.discipline_id,
    }));

    const resourceItems = this.resourceOnlineBookingConfigCollection.map(item => ({
      name: item.resource_name,
      description: item.online_booking_config.defaultValueSwitchModel.allowed_durations
        ? this.$t('global.online_booking_config.default_value.same_as_discipline')
        : this.optionValuesToLabel(
            item.online_booking_config.allowed_durations,
            this.fieldsConfig.allowed_durations.options,
          ).join(', '),
      id: item.resource_id,
    }));

    return [...disciplineItems, ...resourceItems];
  }
  get maxTimeBeforeBookingDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    const disciplineItems = this.disciplineOnlineBookingConfigCollection.map(item => ({
      name: item.discipline_name,
      description: item.online_booking_config.max_time_before_booking,
      id: item.discipline_id,
    }));

    const resourceItems = this.resourceOnlineBookingConfigCollection.map(item => ({
      name: item.resource_name,
      description: item.online_booking_config.defaultValueSwitchModel.max_time_before_booking
        ? this.$t('global.online_booking_config.default_value.same_as_discipline')
        : item.online_booking_config.max_time_before_booking,
      id: item.resource_id,
    }));

    return [...disciplineItems, ...resourceItems];
  }
  get minTimeBeforeBookingDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    const disciplineItems = this.disciplineOnlineBookingConfigCollection.map(item => ({
      name: item.discipline_name,
      description: item.online_booking_config.min_time_before_booking,
      id: item.discipline_id,
    }));

    const resourceItems = this.resourceOnlineBookingConfigCollection.map(item => ({
      name: item.resource_name,
      description: item.online_booking_config.defaultValueSwitchModel.min_time_before_booking
        ? this.$t('global.online_booking_config.default_value.same_as_discipline')
        : item.online_booking_config.min_time_before_booking,
      id: item.resource_id,
    }));

    return [...disciplineItems, ...resourceItems];
  }

  get minTimeBetweenTwoBookingsDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    const disciplineItems = this.disciplineOnlineBookingConfigCollection.map(item => ({
      name: item.discipline_name,
      description: item.online_booking_config.min_time_between_two_bookings,
      id: item.discipline_id,
    }));

    return [...disciplineItems];
  }
  get maxNumberOfOngoingUpcomingBookingsWhenSubscriptionPaymentDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    const disciplineItems = this.disciplineOnlineBookingConfigCollection.map(item => ({
      name: item.discipline_name,
      description:
        item.online_booking_config
          .max_number_of_ongoing_upcoming_bookings_when_subscription_payment,
      id: item.discipline_id,
    }));

    // No resource option

    return [...disciplineItems];
  }
  get maxNumberOfOngoingBookingsPerWeekWhenSubscriptionPaymentDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    const disciplineItems = this.disciplineOnlineBookingConfigCollection.map(item => ({
      name: item.discipline_name,
      description:
        item.online_booking_config
          .max_number_of_ongoing_bookings_per_week_when_subscription_payment,
      id: item.discipline_id,
    }));

    // No resource option

    return [...disciplineItems];
  }
  get allowCancelBookingEventDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    const disciplineItems = this.disciplineOnlineBookingConfigCollection.map(item => ({
      name: item.discipline_name,
      description: item.online_booking_config.allow_cancel_booking_event
        ? this.$t('global.yes')
        : this.$t('global.no'),
      id: item.discipline_id,
    }));

    const resourceItems = this.resourceOnlineBookingConfigCollection.map(item => ({
      name: item.resource_name,
      description: item.online_booking_config.defaultValueSwitchModel.allow_cancel_booking_event
        ? this.$t('global.online_booking_config.default_value.same_as_discipline')
        : item.online_booking_config.allow_cancel_booking_event
        ? this.$t('global.yes')
        : this.$t('global.no'),
      id: item.resource_id,
    }));

    return [...disciplineItems, ...resourceItems];
  }
  get minTimeBeforeCancellationDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    const disciplineItems = this.disciplineOnlineBookingConfigCollection.map(item => ({
      name: item.discipline_name,
      description: item.online_booking_config.min_time_before_cancellation,
      id: item.discipline_id,
    }));

    const resourceItems = this.resourceOnlineBookingConfigCollection.map(item => ({
      name: item.resource_name,
      description: item.online_booking_config.defaultValueSwitchModel.min_time_before_cancellation
        ? this.$t('global.online_booking_config.default_value.same_as_discipline')
        : item.online_booking_config.min_time_before_cancellation,
      id: item.resource_id,
    }));

    return [...disciplineItems, ...resourceItems];
  }
  get membershipRequiredDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    const disciplineItems = this.disciplineOnlineBookingConfigCollection.map(item => ({
      name: item.discipline_name,
      description: item.online_booking_config.membership_required
        ? this.$t('global.yes')
        : this.$t('global.no'),
      id: item.discipline_id,
    }));

    const resourceItems = this.resourceOnlineBookingConfigCollection.map(item => ({
      name: item.resource_name,
      description: item.online_booking_config.defaultValueSwitchModel.membership_required
        ? this.$t('global.online_booking_config.default_value.same_as_discipline')
        : item.online_booking_config.membership_required
        ? this.$t('global.yes')
        : this.$t('global.no'),
      id: item.resource_id,
    }));

    return [...disciplineItems, ...resourceItems];
  }

  get membershipsAllowBookingDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    const disciplineItems = this.disciplineOnlineBookingConfigCollection.map(item => {
      const description = (item.online_booking_config?.memberships_allow_booking || []).length
        ? item.online_booking_config.memberships_allow_booking.join(', ')
        : this.$t('global.none');
      return {
        name: item.discipline_name,
        description: description,
        id: item.discipline_id,
      };
    });

    const resourceItems = this.resourceOnlineBookingConfigCollection.map(item => {
      const description = item.online_booking_config.defaultValueSwitchModel
        .memberships_allow_booking
        ? this.$t('global.online_booking_config.default_value.same_as_discipline')
        : (item.online_booking_config?.memberships_allow_booking || []).length
        ? item.online_booking_config.memberships_allow_booking.join(', ')
        : this.$t('global.none');
      return {
        name: item.resource_name,
        description: description,
        id: item.resource_id,
      };
    });

    return [...disciplineItems, ...resourceItems];
  }

  mounted() {
    if ((this.disciplinesForOnlineBookingIds || []).length > 0) {
      this.loadDisciplineOnlineBookingConfig();
    }
    if ((this.resourcesForOnlineBookingIds || []).length > 0) {
      this.loadResourceOnlineBookingConfig();
    }
  }

  resetFormModel() {
    this.formModel = {
      allowed_durations: [60],
      max_time_before_booking: '14',
      min_time_before_booking: '0',
      allow_cancel_booking_event: false,
      min_time_before_cancellation: '24',
      membership_required: false,
      memberships_allow_booking: [],
      max_number_of_ongoing_upcoming_bookings_when_subscription_payment: '999',
      max_number_of_ongoing_bookings_per_week_when_subscription_payment: '999',
      min_time_between_two_bookings: '12',
      defaultValueSwitchModel: {
        allowed_durations: false,
        max_time_before_booking: false,
        min_time_before_booking: false,
        allow_cancel_booking_event: false,
        min_time_before_cancellation: false,
        membership_required: false,
        memberships_allow_booking: false,
        max_number_of_ongoing_upcoming_bookings_when_subscription_payment: false,
        max_number_of_ongoing_bookings_per_week_when_subscription_payment: true,
        min_time_between_two_bookings: false,
      },
    };
  }

  manageSaveErrors(errors: any) {
    this.errorsObject = {};
    Object.keys(errors).forEach(key => {
      this.$set(this.errorsObject, key, errors[key]);
    });
  }

  optionValueToLabel(value, options) {
    if (!value) {
      return '';
    }

    const option = options.find(option => option.value === value);
    return option ? this.$t(option.text) : value;
  }
  optionValuesToLabel(values, options) {
    if (!values) {
      return [];
    }
    return values.map(value => {
      const option = options.find(option => option.value === value);
      return option ? this.$t(option.text) : value;
    });
  }

  async loadDisciplineOnlineBookingConfig() {
    this.loadingDisciplineOnlineBookingConfig = true;
    const path = this.$bpcApiRouteHelper.getApiPath('disciplines/online-booking-config');
    const params = {
      discipline_ids: this.disciplinesForOnlineBookingIds,
    };
    if (this.disciplineOnlineBookingConfigSubscription) {
      this.disciplineOnlineBookingConfigSubscription.unsubscribe();
    }
    this.disciplineOnlineBookingConfigSubscription = this.$bpcApi.get(path, { params }).subscribe(
      (response: any) => {
        this.disciplineOnlineBookingConfigCollection = response.data;
        this.loadingDisciplineOnlineBookingConfig = false;
      },
      (error: any) => {
        this.loadingDisciplineOnlineBookingConfig = false;
        console.error(error);
      },
    );
  }

  async loadResourceOnlineBookingConfig() {
    this.loadingResourceOnlineBookingConfig = true;
    const path = this.$bpcApiRouteHelper.getApiPath('resources/online-booking-config');
    const params = {
      resource_ids: this.resourcesForOnlineBookingIds,
    };
    if (this.resourceOnlineBookingConfigSubscription) {
      this.resourceOnlineBookingConfigSubscription.unsubscribe();
    }
    this.resourceOnlineBookingConfigSubscription = this.$bpcApi.get(path, { params }).subscribe(
      (response: any) => {
        this.resourceOnlineBookingConfigCollection = response.data;
        this.loadingResourceOnlineBookingConfig = false;
      },
      (error: any) => {
        this.loadingResourceOnlineBookingConfig = false;
        console.error(error);
      },
    );
  }

  async loadDisciplineOnlineBookingConfigIfStopChanging() {
    const changeDetectorStr = this.disciplinesChangeDetectorStr;
    setTimeout(() => {
      if (changeDetectorStr === this.disciplinesChangeDetectorStr) {
        this.loadDisciplineOnlineBookingConfig();
      }
    }, 300);
  }

  async loadResourceOnlineBookingConfigIfStopChanging() {
    const changeDetectorStr = this.resourcesChangeDetectorStr;
    setTimeout(() => {
      if (changeDetectorStr === this.resourcesChangeDetectorStr) {
        this.loadResourceOnlineBookingConfig();
      }
    }, 300);
  }

  @Watch('disciplinesChangeDetectorStr')
  onDisciplinesChange() {
    this.loadDisciplineOnlineBookingConfigIfStopChanging();
  }

  @Watch('resourcesChangeDetectorStr')
  onResourcesChange() {
    this.loadResourceOnlineBookingConfigIfStopChanging();
  }

  @Watch('formModel', { deep: true })
  onFormModelChange() {
    this.$emit('formModelChange', this.formModel);
  }
}
